import { CoveragePlan } from './components'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import { getAvailableRiderCodes } from 'quick-quote/product-common/coverage-plan/selectors'

import {
  toggleRider,
  editRiderSumAssured,
  editRiderSelectedPlan,
} from 'quick-quote/product-common/coverage-plan/actions'

const mapStateToProps = (state) => ({
  riderCodes: getAvailableRiderCodes(state),
  canProceedToCoveragePlan: canProceedToCoveragePlan(state),
  displayProduct: getSelectedDisplayProduct(state),
})

const mapDispatchToProps = (dispatch) => ({
  toggleRider: bindActionCreators(toggleRider, dispatch),
  editRiderSumAssured: bindActionCreators(editRiderSumAssured, dispatch),
  editRiderSelectedPlan: bindActionCreators(editRiderSelectedPlan, dispatch),
})

export const CoveragePlanContainer = connect(mapStateToProps, mapDispatchToProps)(CoveragePlan)
